<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="container-fluid">
    <form [formGroup]="rentalForm">
        <div class="row">
            <div class="col-lg-2 col-xl-2 alignMenu shadow text-left pt-2">
                <app-rental-menu></app-rental-menu>
            </div>
            <div class="col-lg-10 col-xl-10 bgMainSection bgBlue text-left">
                <div class="container mainContainer">
                    <div class="row">
                        <div class="col-5 text-left mt-4">
                            <h2 class="mainHeading mb-0">{{pageName}}</h2>
                        </div>
                        <div class="col-7 text-right pl-0 mt-4" [ngClass]="{'col-lg-5': SwapORamaCustomChanges}">
                            <h1 class="mainHeading mb-0">{{marketName}}</h1>
                        </div>
                        <div class="col-12 col-lg-2 text-left text-lg-right mt-4" *ngIf="SwapORamaCustomChanges">
                            <a class="text-white language-toggle translator" style="text-decoration: none !important;" translate="no" href="javascript:void(0)" onclick="toggleLanguage()">Español</a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left">
                            <button #btnRentOnline class="btn btnMain mr-3 mt-2">Rent Online</button>
                            <button #ContactInfo class="btn btnMain mr-3 mt-2">Current Contact
                                Information</button>
                            <button #btnLoginInfo class="btn btnMain mr-3 mt-2">Online Login
                                Info</button>
                            <button #btnPayment class="btn btnMain mt-2">Payment</button>
                        </div>
                    </div>
                    <div #divRentOnline class="bgWghite shadow pt-2 mt-2"
                        [ngStyle]="{ display: showrentOnline ? 'block' : 'none' }">
                        <div class="container">
                            <div class="row mt-1 pl-4">
                                <div class="col-md-6 col-lg-2 col-sm-12 col-xl-2 ml-lg-3 ml-xl-0"
                                    *ngIf="AllowBookingsDaily">
                                    <input type="radio" id="rdDaily" class="form-check-input" value="1"
                                        formControlName="rentalTypes">
                                    <label for="rdDaily" class="form-check-label">Daily</label>
                                </div>
                                <div class="col-md-6 col-lg-2 col-sm-12 col-xl-2 ml-lg-3 ml-xl-0"
                                    *ngIf="AllowBookingsWeekly">
                                    <input type="radio" id="rdWeekly" class="form-check-input" value="3"
                                        formControlName="rentalTypes">
                                    <label for="rdWeekly" class="form-check-label">Weekly</label>
                                </div>
                                <div class="col-md-6 col-lg-2 col-sm-12 col-xl-2 ml-lg-3 ml-xl-0"
                                    *ngIf="AllowBookingsMonthly">
                                    <input type="radio" id="rdMonthly" class="form-check-input" value="2"
                                        formControlName="rentalTypes">
                                    <label for="rdMonthly" class="form-check-label">Monthly</label>
                                </div>
                                <div class="col-md-6 col-lg-3 col-sm-12 col-xl-3 ml-lg-3 ml-xl-0"
                                    *ngIf="AllowBookingsCw">
                                    <input type="radio" id="rdCombinedWeek" class="form-check-input" value="5"
                                        formControlName="rentalTypes">
                                    <label for="rdCombinedWeek" class="form-check-label">Combined Weekly</label>
                                </div>
                                <div class="col-md-6 col-lg-3 col-sm-12 col-xl-3 ml-lg-3 ml-xl-0"
                                    *ngIf="AllowBookingsCm">
                                    <input type="radio" id="rdCombinedMonth" class="form-check-input" value="4"
                                        formControlName="rentalTypes">
                                    <label for="rdCombinedMonth" class="form-check-label">Combined Monthly</label>
                                </div>
                                <div class="col-md-6 col-lg-3 col-sm-12 col-xl-3 ml-lg-3 ml-xl-0"
                                    *ngIf="AllowBookingsEvent">
                                    <input type="radio" id="rdCombinedMonth" class="form-check-input" value="7"
                                        formControlName="rentalTypes">
                                    <label for="rdCombinedMonth" class="form-check-label">Event</label>
                                </div>
                            </div>
                            <div class="row mt-1 pl-2">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xl-12">
                                    <div class="col-md-12 col-lg-10 col-sm-12 col-xl-10" style="display: inline-block;">
                                        <span *ngIf="this.rentalForm.value['rentalTypes'] == 1"
                                            style="color: #D7232C;font-size:12px;">Booths can be rented
                                            for single or multiple market days on a one time
                                            basis.</span>
                                        <span *ngIf="this.rentalForm.value['rentalTypes'] == 2"
                                            style="color: #D7232C;font-size:12px;">Booths can be rented for
                                            one market day per week on permanent monthly basis.</span>
                                        <span *ngIf="this.rentalForm.value['rentalTypes'] == 3"
                                            style="color: #D7232C;font-size:12px;">Booths can be rented for
                                            one market day in the week on permanent weekly basis.</span>
                                        <span *ngIf="this.rentalForm.value['rentalTypes'] == 4"
                                            style="color: #D7232C;font-size:12px;">Booth can be rented
                                            for all market days in the month on monthly basis.</span>
                                        <span *ngIf="this.rentalForm.value['rentalTypes'] == 5"
                                            style="color: #D7232C;font-size:12px;">Booths can be rented
                                            for all market days in the week on weekly basis.</span>
                                    </div>
                                    <div class="col-md-12 col-lg-2 col-sm-12 col-xl-2" style="display: inline-block;"
                                        *ngIf="companyId == 9">
                                        <a [href]="eventDocURL" target="_blank" class="btn btn-danger py-2">Event
                                            List</a>
                                    </div>
                                    <div class="col-md-12 col-lg-2 col-sm-12 col-xl-2" style="display: inline-block;"
                                        *ngIf="companyId != 9">
                                        <a [href]="howtoRentSpaceDocURL" target="_blank" class="btn btn-danger py-2">How
                                            To Rent</a>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <hr class="my-2" />
                                </div>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '1'">
                                <app-dailyrental-online (isFormDirty)="setDirtyFlag($event)"
                                    (isCancelClicked)="isCancelClicked($event)" [newVendor]=newVendor
                                    (bookingFormCompleted)="bookingFormCompleted($event)"
                                    (rentalBookingData)="rentalBookingData($event)"
                                    (resaleNoInputRequired)="resaleNoInputRequired($event)"
                                    (businessLicenseRequired)="businessLicenseRequired($event)"></app-dailyrental-online>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '2'">
                                <app-monthlyrental-online (isFormDirty)="setDirtyFlag($event)"
                                    (isCancelClicked)="isCancelClicked($event)" [newVendor]=newVendor
                                    (bookingFormCompleted)="bookingFormCompleted($event)"
                                    (rentalBookingData)="rentalBookingData($event)"
                                    (resaleNoInputRequired)="resaleNoInputRequired($event)"
                                    (businessLicenseRequired)="businessLicenseRequired($event)"></app-monthlyrental-online>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '3'">
                                <app-weeklyrental-online (isFormDirty)="setDirtyFlag($event)"
                                    (isCancelClicked)="isCancelClicked($event)" [newVendor]=newVendor
                                    (bookingFormCompleted)="bookingFormCompleted($event)"
                                    (rentalBookingData)="rentalBookingData($event)"
                                    (resaleNoInputRequired)="resaleNoInputRequired($event)"
                                    (businessLicenseRequired)="businessLicenseRequired($event)"></app-weeklyrental-online>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '4'">
                                <app-combinedmonthlyrental-online (isFormDirty)="setDirtyFlag($event)"
                                    (isCancelClicked)="isCancelClicked($event)" [newVendor]=newVendor
                                    (bookingFormCompleted)="bookingFormCompleted($event)"
                                    (rentalBookingData)="rentalBookingData($event)"
                                    (resaleNoInputRequired)="resaleNoInputRequired($event)"
                                    (businessLicenseRequired)="businessLicenseRequired($event)"></app-combinedmonthlyrental-online>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '5'">
                                <app-combinedweeklyrental-online (isFormDirty)="setDirtyFlag($event)"
                                    (isCancelClicked)="isCancelClicked($event)" [newVendor]=newVendor
                                    (bookingFormCompleted)="bookingFormCompleted($event)"
                                    (rentalBookingData)="rentalBookingData($event)"
                                    (resaleNoInputRequired)="resaleNoInputRequired($event)"
                                    (businessLicenseRequired)="businessLicenseRequired($event)"></app-combinedweeklyrental-online>
                            </div>
                            <div *ngIf="this.rentalForm.value['rentalTypes'] == '7'">
                                <app-eventrental-online (isFormDirty)="setDirtyFlag($event)"
                                    (isCancelClicked)="isCancelClicked($event)" [newVendor]=newVendor
                                    (bookingFormCompleted)="bookingFormCompleted($event)"
                                    (rentalBookingData)="rentalBookingData($event)"></app-eventrental-online>
                            </div>
                        </div>
                    </div>
                    <div #divContactInfo class="bgWghite shadow pt-2 mt-2"
                        [ngStyle]="{ display: showContactInfo ? 'block' : 'none' }">
                        <div class="container" formGroupName="VendorForm">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <label for="txtFirstName" i18n>*First Name</label>
                                    <input id="txtFirstName" class="form-control" type="text" #VendorFirstName
                                        formControlName="FirstName" [appAutoCase]="formatId" maxlength="20" required>
                                    <small style="color: #D7232C;"
                                        *ngIf="rentalForm.controls['VendorForm'].get('FirstName').hasError('required')"
                                        i18n>* required </small>
                                    <small style="color: #D7232C;"
                                        *ngIf="rentalForm.controls['VendorForm'].get('FirstName').hasError('maxlength')"
                                        i18n>* max length exceeded
                                    </small>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3"
                                    *ngIf="this.VendorGeneralSetting.VendorNameFormat.includes('Middle Name')">
                                    <label for="txtMiddleName" i18n>Middle Name</label>
                                    <input id="txtMiddleName" class="form-control" type="text"
                                        formControlName="MiddleName" [appAutoCase]="formatId" maxlength="15">
                                    <small style="color: #D7232C;"
                                        *ngIf="rentalForm.controls['VendorForm'].get('MiddleName').hasError('maxlength')"
                                        i18n>* max length exceeded
                                    </small>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3"
                                    *ngIf="this.VendorGeneralSetting.VendorNameFormat.includes('Last Name')">
                                    <label for="txtLastName" i18n><span *ngIf="LastNameMandatory">*</span>Last
                                        Name</label>
                                    <input id="txtLastName" class="form-control" type="text" formControlName="LastName"
                                        [appAutoCase]="formatId" maxlength="15">
                                    <small style="color: #D7232C;"
                                        *ngIf="rentalForm.controls['VendorForm'].get('LastName').hasError('maxlength')"
                                        i18n>* max length exceeded
                                    </small>
                                    <small style="color: #D7232C;"
                                        *ngIf="rentalForm.controls['VendorForm'].get('LastName').hasError('required')"
                                        i18n>* required
                                    </small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <label class="mb-0" for="txtAddress"><span
                                                *ngIf="AddressMandatory">*</span>Address</label>
                                        <input id="txtAddress" class="form-control" type="text"
                                            formControlName="Address" maxlength="50">
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('Address').hasError('maxlength')"
                                            i18n>* max length exceeded </small>
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('Address').hasError('required')"
                                            i18n>* required </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <label class="mb-0" for="txtCity"><span
                                                *ngIf="AddressMandatory">*</span>City</label>
                                        <input id="txtCity" class="form-control" type="text" formControlName="City"
                                            [appAutoCase]="caseCode" maxlength="30">
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('City').hasError('required')"
                                            i18n>* required </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <span class="mb-0" for="StateCombobox"><span
                                                *ngIf="AddressMandatory">*</span>State/ Province</span>
                                        <ejs-combobox id='StateCombobox' #State *ngIf="showStateDropDown"
                                            [fields]='DropDownfieldsState' [dataSource]='StateList'
                                            formControlName="State" [allowFiltering]='true' allowCustom=true
                                            placeholder='' (created)="lockStateComboBoxTranslation()" (open)="lockStateComboBoxTranslation()"></ejs-combobox>

                                        <input type="text" *ngIf="!showStateDropDown" maxlength="2" class="form-control"
                                            formControlName="State">

                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('State').hasError('required')"
                                            i18n>*
                                            required </small>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <label class="mb-0" for="ddlCountry">*Country</label>
                                        <select id="ddlCountry" class="form-control" formControlName="CountryCode"
                                            (change)="DropDownCountryChange($event)" translate="no">
                                            <option *ngFor="let ct of countryList" [value]="ct.Code">{{ct.Name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <span class="mb-0"><span *ngIf="AddressMandatory">*</span>Zip/Postal Code</span>
                                        <ejs-maskedtextbox [mask]="ZipCodeMask" *ngIf="showZipCodeAsTxt" name="ZipCode"
                                            id="ZipCode" formControlName="ZipCode"
                                            (blur)="UpdateStateAndCityByZipcode()"></ejs-maskedtextbox>
                                        <input type="text" *ngIf="!showZipCodeAsTxt" class="form-control"
                                            formControlName="ZipCode" (blur)="UpdateStateAndCityByZipcode()"
                                            maxlength="30">

                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('ZipCode').hasError('required')"
                                            i18n>* required </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <label class="mb-0" for="telephone"><span
                                                *ngIf="WorkPhoneMandatory">*</span>Work Phone</label>
                                        <!-- <input class="form-control" type="text" formControlName="WorkPhone"> -->
                                        <ejs-maskedtextbox [mask]="PhoneNumberMask" name="WorkPhone" id="telephone"
                                            formControlName="WorkPhone"
                                            (keyup)="onKeyUp('WorkPhone')"></ejs-maskedtextbox>
                                        <small style="color: #D7232C;" *ngIf="showWorkPhoneError" i18n>Enter valid work
                                            phone number</small>
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('WorkPhone').hasError('required')"
                                            i18n>* required </small>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <label class="mb-0" for="CellPhone"><span
                                                *ngIf="CellPhoneMandatory">*</span>Cell Phone</label>
                                        <!-- <input class="form-control" type="text" formControlName="CellPhone"> -->
                                        <ejs-maskedtextbox [mask]="PhoneNumberMask" name="CellPhone" id="CellPhone"
                                            formControlName="CellPhone"
                                            (keyup)="onKeyUp('CellPhone')"></ejs-maskedtextbox>
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('CellPhone').hasError('minlength')"
                                            i18n>* not complete</small>
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('CellPhone').hasError('required')"
                                            i18n>* required </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <label class="mb-0" for="txtEmail"><span
                                                *ngIf="rentalForm.controls['VendorForm'].get('Email').hasError('required')">*</span>Email</label>
                                        <input id="txtEmail" class="form-control" type="text" formControlName="Email"
                                            maxlength="50">
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('Email').hasError('required')"
                                            i18n>* required </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <label class="mb-0" for="txtDriverLicense"><span
                                                *ngIf="DLNoMandatory">*</span>Drivers License</label>
                                        <input id="txtDriverLicense" class="form-control" type="text"
                                            formControlName="DriverLicenseNumber" maxlength="20">
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('DriverLicenseNumber').hasError('required')"
                                            i18n>* required </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <span class="mb-0" for="filterWorkOrderCreatedDate"><span
                                                *ngIf="DLExpiryDateMandatory">*</span>DL Expiry Date</span>
                                        <ejs-datepicker format='MM/dd/yyyy' [allowEdit]=false
                                            id="filterWorkOrderCreatedDate" formControlName="DLExpiryDate"
                                            i18n-placeholder="DL Expiry Date"
                                            placeholder="DL Expiry Date"></ejs-datepicker>
                                        <div>
                                            <small style="color: #D7232C;"
                                                *ngIf="rentalForm.controls['VendorForm'].get('DLExpiryDate')?.invalid"
                                                i18n>* required </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <span class="mb-0" for="DLStateCombobox"><span
                                                *ngIf="DLStateMandatory">*</span>DL State</span>
                                        <ejs-combobox id='DLStateCombobox' #DLState *ngIf="showStateDropDown"
                                            [fields]='DropDownfieldsState' [popupHeight]="200" [dataSource]='StateList'
                                            formControlName="DLState" [allowFiltering]='true' allowCustom=true
                                            [placeholder]="'Select State'"
                                            filterBarPlaceholder="Search for State/Province" (created)="lockDLStateComboBoxTranslation()" (open)="lockDLStateComboBoxTranslation()"></ejs-combobox>

                                        <!-- <ejs-combobox id='StateCombobox' #DLState *ngIf="!showUsStateDropDown" [fields]='DropDownfieldsState' [dataSource]='NoneUsStateList' formControlName="DLState" [allowFiltering]='true'
                                                                            allowCustom=true placeholder = '' ></ejs-combobox> -->

                                        <input type="text" id='DLStateCombobox' *ngIf="!showStateDropDown" maxlength="2"
                                            class="form-control" formControlName="DLState">
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('DLState')?.hasError('required')"
                                            i18n>*
                                            required </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3" *ngIf="!SevenMileWRWarningMsg">
                                    <div>
                                        <label class="mb-0" for="ResaleNumber"><span
                                                *ngIf="resaleNumberRequired">*</span>Resale #</label>
                                        <input id="txtResaleNumber" class="form-control" type="text"
                                            formControlName="ResaleNumber" id="ResaleNumber">
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('ResaleNumber')?.hasError('required')"
                                            i18n>* required </small>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <label class="mb-0" for="txtCompanyName"><span
                                                *ngIf="CompanyNameMandatory">*</span>Business Name</label>
                                        <input id="txtCompanyName" class="form-control" type="text"
                                            formControlName="CompanyName" maxlength="50">
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('CompanyName').hasError('required')"
                                            i18n>* required
                                        </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <label class="mb-0" for="txtBusinessLicenseNumber"><span
                                                *ngIf="businessLicenseNoRequired">*</span>{{SevenMileWRWarningMsg?"Wisconsin
                                            Seller Permit (15 digits starting with 456)":"Business License #"}}</label>
                                        <input id="txtBusinessLicenseNumber" class="form-control" type="text"
                                            formControlName="BusinessLicenseNumber" maxlength="50">
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('BusinessLicenseNumber').hasError('required')"
                                            i18n>* required
                                        </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3"
                                    *ngIf="businessLicenseNoRequired">
                                    <div>
                                        <label class="mb-0" for="BusinessLicenseExpiryDate"><span
                                                *ngIf="businessLicenseNoRequired">*</span>Business License Expiry
                                            Date</label>
                                        <input type="date" id="BusinessLicenseExpiryDate" class="form-control"
                                            formControlName="BusinessLicenseExpiryDate"
                                            [maxlength]="SevenMileWRWarningMsg?15:25"
                                            [placeholder]="'Business License Expiry Date'"
                                            i18n-placeholder="Business License Expiry Date">
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('BusinessLicenseExpiryDate').hasError('required')"
                                            i18n>* required </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <span class="mb-0" for="ProductPriority">* Primary Selling Product</span>
                                        <ejs-combobox id="ProductPriority" [dataSource]="productList"
                                            [allowCustom]="false" [fields]="ProductDropDownfields" [popupHeight]="200"
                                            formControlName="ProductPriority"
                                            (valueChange)="primaryproductchange($event)"></ejs-combobox>
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('ProductPriority').invalid"
                                            i18n>*
                                            required</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <span class="mb-0" for="ddlType">* Vendor Type</span>
                                        <!-- <input class="form-control" type="text" formControlName="VendorType"> -->

                                        <ejs-dropdownlist id="ddlType" [dataSource]="VendorTypeList"
                                            [fields]="{text:'VtyTxtVendorType',value:'VtyTxtVendorType'}"
                                            formControlName="VendorType" placeholder="Select Vendor Type">

                                        </ejs-dropdownlist>
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('VendorType').invalid" i18n>*
                                            required</small>

                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3" *ngIf="!SevenMileWRWarningMsg">
                                    <div>
                                        <label class="mb-0" for="txtSSN"><span *ngIf="SSNMandatory">*</span>SSN</label>
                                        <ejs-maskedtextbox id="txtSSN" [mask]="SSNMask " name="txtSSN"
                                            formControlName="SSN"></ejs-maskedtextbox>
                                        <small style="color: #D7232C;" *ngIf="rentalForm.controls['VendorForm'].get('SSN')?.hasError('required')" i18n>*
                                            required </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3" *ngIf="SevenMileWRWarningMsg">
                                  <div>
                                    <label class="mb-0" for="txtSSN"><span *ngIf="SSNMandatory">*</span>SSN</label>
                                    <ejs-maskedtextbox id="txtSSN" [mask]="SevenMileWRWarningMsg ? SSNMask2 : SSNMask " name="txtSSN"
                                      formControlName="ResaleNumber"></ejs-maskedtextbox>
                                    <small style="color: #D7232C;" *ngIf="rentalForm.controls['VendorForm'].get('ResaleNumber')?.hasError('required')" i18n>*
                                      required </small>
                                  </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div>
                                        <label class="mb-0" for="txtTaxID"><span
                                                *ngIf="TaxIDMandatory">*</span>{{SevenMileWRWarningMsg?"FEIN Number(Last
                                            4digits)":"Tax ID"}}</label>
                                        <input id="txtTaxID" class="form-control" type="text" formControlName="TaxID"
                                            maxlength="20" *ngIf="!SevenMileWRWarningMsg">
                                        <ejs-maskedtextbox id="txtTaxID" [mask]="FEINMask" name="txtTaxID"
                                            formControlName="TaxID" *ngIf="SevenMileWRWarningMsg"></ejs-maskedtextbox>
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('TaxID').hasError('required')"
                                            i18n>*
                                            required </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3" *ngIf="companyId == 29">
                                    <div>
                                        <label class="mb-0" for="txtProductDescription"><span
                                                *ngIf="rentalForm.controls['VendorForm'].get('VendorDescription').hasError('required')">*</span>Product
                                            Description</label>
                                        <textarea id="txtProductDescription" class="form-control" type="text"
                                            formControlName="VendorDescription" maxlength="350"></textarea>
                                        <small style="color: #D7232C;"
                                            *ngIf="rentalForm.controls['VendorForm'].get('VendorDescription').hasError('required')"
                                            i18n>*
                                            required </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div class="uploadPhoto">
                                        <div class="market_logo" style="position: relative;">
                                            <div class="market_img edit_vendor_image">
                                                <img class="userIcon img-fluid"
                                                    [src]="rentalForm.controls['VendorForm'].get('VendorProfile')?.value == '' ? '../../../assets/images/NoImage.jpg' : rentalForm.controls['VendorForm'].get('VendorProfile')?.value"
                                                    loading="lazy" alt="Vendor Photo">
                                                <label class="btn btn-danger edit_MarketLogo float-right"
                                                    *ngIf="rentalForm.controls['VendorForm'].get('VendorProfile')?.value != '../../../assets/images/NoImage.jpg' && rentalForm.controls['VendorForm'].get('VendorProfile')?.value != '' "
                                                    (click)="RemoveVendorImage()">
                                                    <i class="fa fa-trash"></i>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                                            <!-- <div class="file-upload">
                                                <label for="fileVendorPhoto" class="custom-button" i18n>
                                                    ADD VENDOR PHOTO
                                                </label>
                                                <input id="fileVendorPhoto" type="file" (change)="VendorPhotoUpload($event)" accept="image/*" />
                                                <span class="file-name" style="display: none;" i18n>No file chosen</span>
                                            </div> -->
                                            <div class="file-upload text-center mt-2">
                                                <label for="fileVendorPhoto" class="custom-button" i18n>ADD VENDOR
                                                    PHOTO</label>
                                                <input id="fileVendorPhoto" type="file"
                                                    (change)="VendorPhotoUpload($event)" accept="image/*" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mt-3">
                                    <div class="uploadPhoto">
                                        <div class="market_logo" style="position: relative;">
                                            <div class="market_img edit_vendor_image">
                                                <img class="userIcon img-fluid"
                                                    *ngIf="VendorProductsImageList.length == 0"
                                                    (click)="ViewAllProductImages(VendorProductImages)"
                                                    src="../../../assets/images/NoImage.jpg" loading="lazy"
                                                    alt="Vendor Product No Image 1">
                                                <img class="userIcon img-fluid"
                                                    *ngIf="VendorProductsImageList.length != 0"
                                                    (click)="ViewAllProductImages(VendorProductImages)"
                                                    [src]="VendorProductsImageList[VendorProductsImageList.length - 1].ProductImageUrl"
                                                    loading="lazy" alt="Vendor Product Image 1">
                                                <span (click)="ViewAllProductImages(VendorProductImages)"
                                                    class="btn btn-primary edit_MarketLogo float-right">
                                                    <i class="fa fa-expand"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                                            <!-- <div class="file-upload">
                                                <label for="fileProductPhoto" class="custom-button" i18n>
                                                    ADD PRODUCT PHOTO
                                                </label>
                                                <input id="fileProductPhoto" type="file" (change)="handleImageSelection($event)" accept="image/*" />
                                                <span class="file-name" style="display: none;" i18n>No file chosen</span>
                                            </div> -->
                                            <div class="file-upload text-center mt-2">
                                                <label for="fileProductPhoto" class="custom-button" i18n>ADD PRODUCT
                                                    PHOTO</label>
                                                <input id="fileProductPhoto" type="file"
                                                    (change)="handleImageSelection($event)" accept="image/*" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-right mb-3">
                                    <button class="btn btn-outline-primary mt-3 mr-1"
                                        (click)="rentOnline()">Back</button>
                                    <button class="btn btn-outline-primary mt-3 mr-2"
                                        (click)="cancelContactModification()">Cancel</button>
                                    <button class="btn btn-primary mt-3"
                                        (click)="ValidationVendorDetails()">Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div #divLoginInfo class="bgWghite shadow pt-2 mt-2"
                        [ngStyle]="{ display: showLoginInfo ? 'block' : 'none' }">
                        <div class="container" formGroupName="OnlineAccessForm">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="txtUserName">*User Name</label>
                                        <input id="txtUserName" class="form-control" type="text"
                                            formControlName="UserName" maxlength="20">
                                        <small
                                            *ngIf="rentalForm.controls['OnlineAccessForm'].get('UserName')?.invalid && (rentalForm.controls['OnlineAccessForm'].get('UserName')?.dirty || rentalForm.controls['OnlineAccessForm'].get('UserName')?.touched)"
                                            style="color: #D7232C;">
                                            <span
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('UserName').hasError('required')"
                                                i18n>*
                                                required</span>
                                            <span
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('UserName').hasError('minlength')"
                                                i18n>*
                                                minimum length is 6 characters</span>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="txtPassword">*Password</label>
                                        <input id="txtPassword" class="form-control" type="password"
                                            formControlName="Password" maxlength="20">
                                        <small
                                            *ngIf="rentalForm.controls['OnlineAccessForm'].get('Password')?.errors && (rentalForm.controls['OnlineAccessForm'].get('Password')?.dirty || rentalForm.controls['OnlineAccessForm'].get('Password')?.touched)"
                                            style="color: #D7232C;">
                                            <div
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('Password').errors.required">
                                                *password is
                                                required.</div>
                                            <div
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('Password').errors.minLength">
                                                *password must be
                                                at least 6 characters long.</div>
                                            <div
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('Password').errors.maxlength">
                                                *password must be
                                                at least 20 characters long.</div>
                                            <div
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('Password').errors.specialChar">
                                                *password must
                                                contain at least one special
                                                character.</div>
                                            <div
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('Password').errors.upperCase">
                                                *password must
                                                contain at least one uppercase letter
                                                .</div>
                                            <div
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('Password').errors.lowerCase">
                                                *password must
                                                contain at least one lowercase letter
                                                .</div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="txtConfirmPassword">*Confirm Password</label>
                                        <input id="txtConfirmPassword" class="form-control" type="password"
                                            formControlName="ConfirmPassword" maxlength="20">
                                        <small
                                            *ngIf="rentalForm.controls['OnlineAccessForm'].get('ConfirmPassword').errors && (rentalForm.controls['OnlineAccessForm'].get('ConfirmPassword').dirty || rentalForm.controls['OnlineAccessForm'].get('ConfirmPassword').touched)"
                                            style="color: #D7232C;">
                                            <div
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('ConfirmPassword').hasError('required')">
                                                *confirm password is
                                                required.</div>
                                        </small>
                                        <small
                                            *ngIf="(rentalForm.controls['OnlineAccessForm'].get('ConfirmPassword').dirty || rentalForm.controls['OnlineAccessForm'].get('ConfirmPassword').touched)"
                                            style="color: #D7232C;">
                                            <div
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('Password').value !== rentalForm.controls['OnlineAccessForm'].get('ConfirmPassword').value">
                                                *Confirm password does not match.
                                            </div>
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="txtSecurityQuestion">*Security Question</label>
                                        <select id="txtSecurityQuestion" class="form-control"
                                            formControlName="SecurityQuestion">
                                            <option *ngFor="let sq of securityQuestions" [value]="sq.ID">
                                                {{sq.SecurityQuestion}}</option>
                                        </select>
                                        <small
                                            *ngIf="(rentalForm.controls['OnlineAccessForm'].get('SecurityQuestion').dirty || rentalForm.controls['OnlineAccessForm'].get('SecurityQuestion').touched)"
                                            style="color: #D7232C;">
                                            <div
                                                *ngIf="rentalForm.controls['OnlineAccessForm'].get('SecurityQuestion').hasError('required')">
                                                *security question is
                                                required.</div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="txtAnswer">*Answer</label>
                                        <input id="txtAnswer" class="form-control" type="text" formControlName="Answer"
                                            maxlength="50">
                                    </div>
                                    <small
                                        *ngIf="(rentalForm.controls['OnlineAccessForm'].get('Answer').dirty || rentalForm.controls['OnlineAccessForm'].get('Answer').touched)"
                                        style="color: #D7232C;">
                                        <div
                                            *ngIf="rentalForm.controls['OnlineAccessForm'].get('Answer').hasError('required')">
                                            *security answer is
                                            required.</div>
                                    </small>
                                </div>
                            </div>
                            <div class="row" style="display: none;"
                                *ngIf="this.registrationFee.RegistrationFee!==0 && this.registrationFee.ChargeVendorRegistration">
                                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-left mt-3">
                                    <div>
                                        <label class="mb-0" for="txtRegistrationFee">*Registration Fee</label>
                                        <input id="txtRegistrationFee" class="form-control text-right" type="text"
                                            [disabled]="true"
                                            [value]="rentalForm.controls['OnlineAccessForm'].get('RegistrationFee').value">
                                    </div>
                                </div>
                            </div>
                            <div class="row"
                                *ngIf="this.registrationFee.RegistrationFee!==0 && this.registrationFee.ChargeVendorRegistration">
                                <div class="col-12 text-left mt-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="chkCreditCard"
                                            formControlName="registrationPaymentCheck">
                                        <label class="form-check-label" for="chkCreditCard">
                                            I authorize ABC Flea Market to charge this amount to my Credit Card. Upon
                                            authorization and full payment by the issuing card company, ABC Flea Market
                                            will
                                            submit a confirmation number, as verification of charged transaction, to the
                                            above named cardholder.
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="display: none;">
                                <div class="col-12 text-left mt-2">
                                    <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS4xMjQiIGhlaWdodD0iMTUuODQzIiB2aWV3Qm94PSIwIDAgMjEuMTI0IDE1Ljg0MyI+CiAgPHBhdGggaWQ9Ikljb25fYXdlc29tZS1oYW5kLXBvaW50LXJpZ2h0IiBkYXRhLW5hbWU9Ikljb24gYXdlc29tZS1oYW5kLXBvaW50LXJpZ2h0IiBkPSJNMjEuMTI0LDEwLjFBMS44NiwxLjg2LDAsMCwxLDE5LjI3NiwxMS45aC00LjEyYTIuMDI5LDIuMDI5LDAsMCwxLS4yNiwyLjkyNywxLjg5LDEuODksMCwwLDEtLjY3OSwyLjU3MWMuMzcsMi4wMjctLjkwNSwyLjk0LTMsMi45NC0uMTEzLDAtLjU0OC0uMDA4LS42Ni0uMDA4LTIuNTU3LjAwNy0zLjE3Mi0xLjI4Mi01LjEtMS41ODFhLjk4OS45ODksMCwwLDEtLjgzNi0uOTc4VjEwLjdoMEExLjk4LDEuOTgsMCwwLDEsNS44LDguODljMS4xOTItLjUzNiwzLjkzNy0yLjAyMyw0LjQzNy0zLjE5YTEuNzU5LDEuNzU5LDAsMCwxLDEuNjUtMS4yQTEuOTgyLDEuOTgyLDAsMCwxLDEzLjcsNy4yNmE1LjYwOCw1LjYwOCwwLDAsMS0uNTg0LDEuMDI4aDYuMTU3QTEuODksMS44OSwwLDAsMSwyMS4xMjQsMTAuMVptLTE3LjE2My4wMTR2Ny45MjJhLjk5Ljk5LDAsMCwxLS45OS45OUguOTlhLjk5Ljk5LDAsMCwxLS45OS0uOTlWMTAuMTExYS45OS45OSwwLDAsMSwuOTktLjk5aDEuOThBLjk5Ljk5LDAsMCwxLDMuOTYxLDEwLjExMVpNMi44MDYsMTcuMDQyYS44MjUuODI1LDAsMSwwLS44MjUuODI1QS44MjUuODI1LDAsMCwwLDIuODA2LDE3LjA0MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTQuNSkiIGZpbGw9IiMwNzI4ZmYiLz4KPC9zdmc+Cg=="
                                        class="img-fluid" alt="hand arrow icon" />
                                    &nbsp;<a [href]="rulesAndRegulations" target="_blank" class="rules">Click here to
                                        read the Rules and Regulations</a>
                                </div>
                            </div>
                            <div class="row" style="display: none;">
                                <div class="col-12 text-left mt-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="chkRules"
                                            formControlName="registrationRuleReadCheck">
                                        <label class="form-check-label" for="chkRules">
                                            By checking this box, I acknowledge that I have read, understand, and agree
                                            to
                                            the rules and regulations, and will Abide by them. Please visit the office
                                            for a
                                            copy of the rules and regulations
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-right mb-3">
                                    <button class="btn btn-outline-primary mt-3 mr-1"
                                        (click)="contactInfo()">Back</button>
                                    <button class="btn btn-outline-primary mt-3 mr-1"
                                        (click)="Oncancel()">Cancel</button>
                                    <button class="btn btn-primary mt-3 mr-1" (click)="openPaymentPage()">Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div #divPayemntInfo class="bgWghite shadow pt-2 mt-2" *ngIf="openPaymentDetails && showPaymentPage"
                        style="padding-bottom: 2rem;">
                        <app-vendor-payments (isConfirmationPageDisplayed)="isConfirmationPageDisplayed($event)"
                            [newVendor]="newVendor" [businessLicenseInfo]="businessLicenseInfo"
                            (cancelClick)="paymentCancelClick($event)"></app-vendor-payments>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<ng-template #VendorProductImages style="max-width: 50px;">
    <div class="modal-header">
        <h4 class="modal-title font-weight-normal" id="exampleModalLabel" i18n>Vendor products</h4>
        <button type="button" class="close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body ptb24" style="max-height: 400px;">
        <div class="row mx-0 mt-3">
            <div class="col-md-6 col-lg-4 mb-2" *ngFor="let item of VendorProductsImageList;let i = index">
                <div class="uploadPhoto ">
                    <div class="market_logo" style="position: relative;">
                        <label (click)="removeimage(i)" class="btn btn-danger edit_MarketLogo float-right"
                            style="bottom: auto !important; top: 5px !important;">
                            <i class="fa fa-close"></i>
                        </label>
                        <div class="market_img edit_vendor_image" style="height: auto !important;">
                            <img class="userIcon img-fluid" [src]="item.ProductImageUrl" loading="lazy"
                                style="height: auto !important;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4" *ngIf="VendorProductsImageList.length == 0">
                No Records
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary mr-3" (click)="modalRef.hide()">Cancel</button>
        </div>
    </div>
</ng-template>
